/* eslint-disable */
import * as THREE from 'three'
import n from './r1.js'
import c from './c11.js'
import { u149, u407 } from './h.js'
import h from './b.js'
import d from './deep5.js'

var r = function (e) {
  function l(e, t) {
    !function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function")
    }(this, l);
    var n = u149
      , i = u407
      , r = new THREE.PlaneGeometry(t.w, t.h)
      , o = h.default.get("" + e)
      , a = new THREE.ShaderMaterial({
        uniforms: {
          u_originalImage: {
            type: "t",
            value: o
          },
          u_offset: {
            type: "v2",
            value: {
              x: 0,
              y: 0
            }
          },
          u_resolution: {
            type: "v2",
            value: {
              x: window.w,
              y: window.h
            }
          },
          u_angle: {
            type: "f",
            value: 0
          },
          u_opacity: {
            type: "f",
            value: 0
          }
        },
        vertexShader: n,
        fragmentShader: i,
        transparent: !0,
        depthTest: !1
      })
      , s = function (e, t) {
        if (!e)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t
      }(this, (l.__proto__ || Object.getPrototypeOf(l)).call(this, r, a));
    return s.options = (0,
      c.merge)({
        amplitude: 50,
        depth: 1,
        ox: 0,
        oy: 0,
        w: 500,
        h: 500,
        angle: 0
      }, t),
      s.mouseRatio = {
        x: 0,
        y: 0
      },
      s.nMouse = {
        x: 0,
        y: 0
      },
      s.noise = new d.default,
      s.perlin = {
        x: 0,
        y: 0
      },
      s.oPosition = {
        x: s.options.ox,
        y: s.options.oy
      },
      s.material.uniforms.u_angle.value = THREE.Math.degToRad(s.options.angle),
      s
  }
  return function (e, t) {
    if ("function" != typeof t && null !== t)
      throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }),
      t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
  }(l, THREE.Mesh),
    n(l, [{
      key: "display",
      value: function () {
        var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 0;
        TweenMax.to(this.material.uniforms.u_opacity, 3, {
          value: 1,
          ease: Power2.easeOut,
          delay: e
        })
      }
    }, {
      key: "hide",
      value: function () { }
    }, {
      key: "parallax",
      value: function (e, t) {
        this.perlin.x += .006,
          this.perlin.y += .0085,
          this.oPosition.y = this.options.oy - window.h / this.options.depth * t + (100 * this.noise.getVal(this.perlin.y) - 50) / this.options.depth,
          this.oPosition.x = this.options.ox + (200 * this.noise.getVal(this.perlin.x) - 100) / this.options.depth,
          this.material.uniforms.u_offset.value.x = (this.oPosition.x + this.options.amplitude * e.x / this.options.depth).toFixed(2),
          this.material.uniforms.u_offset.value.y = (this.oPosition.y + this.options.amplitude * e.y / this.options.depth).toFixed(2)
      }
    }, {
      key: "resize",
      value: function (e) {
        this.material.uniforms.u_resolution.value.x = window.w,
          this.material.uniforms.u_resolution.value.y = window.h,
          this.material.uniforms.u_offset.x = this.options.ox * e,
          this.material.uniforms.u_offset.y = this.options.oy * e
      }
    }, {
      key: "dispose",
      value: function () {
        TweenMax.killTweensOf(this.material.uniforms.u_opacity),
          this.noise.dispose(),
          this.noise = null,
          this.options = this.mouseRatio = this.nMouse = this.perlin = null,
          this.oPosition = null,
          this.material.dispose(),
          this.material = null,
          this.geometry.dispose(),
          this.geometry = null
      }
    }]),
    l
}();
var t = { default: r }

export default t
